import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrFormikField from 'client/components/SrFormikField';
import SrText from 'client/components/SrText';

export const SR_FORM_FIELD_GROUP_THEME_RENTAL_APPLICATION_LIST = 'rentalApplicationList';
export const SR_FORM_FIELD_GROUP_THEME_RENTAL_APPLICATION_GROUP = 'rentalApplicationGroup';

const SrFormFieldGroup = ({ title, label, subtitle, formFields, formikBag, theme }) => {
  if (formFields.length === 0) {
    return null;
  }

  return (
    <div className={classnames('SrFormFieldGroup', theme)}>
      {title && (
        <div className='SrFormFieldGroupTitle'>
          {title}
          {label && (
            <SrText>
              {` ${label}`}
            </SrText>
          )}
          {subtitle}
        </div>
      )}
      <div className='SrFormFieldGroupContent'>
        {formFields.map((formField) => (
          <SrFormikField key={formField.id} formField={formField} formikBag={formikBag} />
        ))}
      </div>
    </div>
  );
};

SrFormFieldGroup.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  formFields: PropTypes.array.isRequired,
  formikBag: PropTypes.object.isRequired,
  theme: PropTypes.oneOf([
    SR_FORM_FIELD_GROUP_THEME_RENTAL_APPLICATION_LIST,
    SR_FORM_FIELD_GROUP_THEME_RENTAL_APPLICATION_GROUP,
  ]),
};

SrFormFieldGroup.defaultProps = {
  theme: SR_FORM_FIELD_GROUP_THEME_RENTAL_APPLICATION_LIST,
};

SrFormFieldGroup.displayName = 'SrFormFieldGroup';

export default SrFormFieldGroup;
